// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__VRc52","pointer":"Icon_pointer__FAAel"};